import React from 'react';
import HostForm from '../../components/host/HostForm';

const HostFormPage = () => {
  return (
    <div>
      <HostForm />
    </div>
  );
};

export default HostFormPage;